import { UseBankInformationv3 } from "../server/fetcher";

/**
 * Payment details for the payment screens.
 *
 * Calls /bank/account/information/v3 and nothing else. v1 and v2 exist only so that cobro
 * bundles cached before v3 shipped keep working - those call the older routes from their
 * own compiled copy, so backward compatibility lives entirely on the server. A freshly
 * loaded app must never reach for them: v2 is not supported going forward, and quietly
 * falling back to it would keep a dead shape alive in new code.
 *
 * The payload goes straight to RenderBankAccounts, which renders its own empty state if
 * the data is missing or not the shape it expects.
 */
export default function useBankAccounts(owner_id) {
  const { data, isLoading, failed, error, mutate, key } = UseBankInformationv3(owner_id);

  return { data, isLoading, failed, error, mutate, key };
}
